import { render, staticRenderFns } from "./ParentAuthForm.vue?vue&type=template&id=26274c40&scoped=true&"
import script from "./ParentAuthForm.vue?vue&type=script&lang=js&"
export * from "./ParentAuthForm.vue?vue&type=script&lang=js&"
import style0 from "./ParentAuthForm.vue?vue&type=style&index=0&id=26274c40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26274c40",
  null
  
)

export default component.exports